import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withPrimeContext from "../withPrimeContext";
import { DualPriceStickyBar } from "~/components/engage/DualPriceStickyBar";

export default withPrimeContext(
  withErrorBoundary(DualPriceStickyBar, {
    name: "DualPriceStickyBar",
  }),
);
